<template>
    <div v-if="cards && cards.length > 0" class="d-flex  gap-3 p-3 bg-white rounded">
        <!-- Cards Individuais para Cada Ponto -->
        <div v-for="(card, index) in cards" :key="index"
             class="volume-card card shadow-sm p-3 bg-light text-center border rounded">
            <span class="volume-card-title fw-semibold text-dark position-absolute top-0 start-0 ms-2 mt-2">Ponto {{
                    index + 1
                }}</span>
            <span class="volume-value display-6 fw-bold text-dark" style="font-size: 22px;">{{ floatToDecimal(card.y) }} m³</span>
            <span class="volume-card-date small text-muted" style="font-size: 14px;">{{ convertDateHour(card.x) }}</span>
        </div>

        <!-- Card da Diferença entre Pontos -->
        <div class="volume-card card shadow-sm p-3 bg-light text-center border rounded">
            <span class="volume-card-title fw-semibold text-dark position-absolute top-0 start-0 ms-2 mt-2">Diferença entre Pontos</span>
            <span class="volume-value display-6 fw-bold text-dark" style="font-size: 22px;">{{ calculateDifference() }} m³</span>
<!--            <span class="volume-card-date small text-muted"-->
<!--                  style="font-size: 14px;">Atualizado em: {{ formatFullDate(new Date()) }}</span>-->
        </div>

        <!-- Card da Taxa por Hora -->
        <div class="volume-card card shadow-sm p-3 bg-light text-center border rounded">
            <span class="volume-card-title fw-semibold text-dark position-absolute top-0 start-0 ms-2 mt-2">Taxa por Hora</span>
            <span class="volume-value display-6 fw-bold text-dark" style="font-size: 22px;">{{ calculateRatePerHour() }} m³/h</span>
<!--            <span class="volume-card-date small text-muted"-->
<!--                  style="font-size: 14px;">Atualizado em: {{ formatFullDate(new Date()) }}</span>-->
        </div>
    </div>

    <div v-else class="text-center text-secondary p-4">
        <p>Sem dados disponíveis.</p>
    </div>
</template>

<script>
export default {
    props: {
        cards: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        floatToDecimal(value) {
            return parseFloat(value).toFixed(2);
        },
        formatFullDate(timestamp) {
            const date = new Date(timestamp);
            // const options = {
            //   day: 'numeric',
            //   month: 'short',
            //   year: 'numeric',
            //   hour: '2-digit',
            //   minute: '2-digit'
            // };
            return date.toLocaleDateString('pt-BR');
        },

        convertDateHour(date) {
            const data = new Date(date)

            return `${String(data.getDate()).padStart(2, '0')}/${String(data.getMonth() + 1).padStart(2, '0')}/${data.getFullYear()} ${String(data.getHours()).padStart(2, '0')}:${String(data.getMinutes()).padStart(2, '0')}`;
        },

        calculateDifference() {
            if (this.cards.length >= 2) {
                let diff = this.cards[0].y - this.cards[1].y;
                if (diff < 0) diff = diff * (-1);
                return this.floatToDecimal(diff);
            }
            return 'N/A';
        },
        calculateRatePerHour() {
            if (this.cards.length >= 2) {
                const volumeDiff = this.cards[0].y - this.cards[1].y;
                const timeDiff = (new Date(this.cards[0].x) - new Date(this.cards[1].x)) / (1000 * 60 * 60); // Convert to hours
                let div = volumeDiff / timeDiff;
                if (div < 0) div = div * (-1);

                return this.floatToDecimal(div);
            }
            return 'N/A';
        }
    }
};
</script>

<style scoped>
.volume-card-title {
    font-size: 0.85rem;
}

.volume-value {
    margin-top: 1.1rem;
}

.volume-card {
    width: 100%;
    /* height: 180px; */
}
</style>
